import React from 'react';
import { Link } from 'react-router';
import {
  STUDIO_COPY,
  STUDIO_PRICING,
  formatCapReachedCopy,
} from '../config';
import { formatResetDate } from '../utils/format';

type CapReachedCardProps = {
  variant?: 'free' | 'paid';
  periodCap?: number;
  periodResetsAt?: string;
};

/** Hard block at the reel cap — free upsell vs paid monthly reset. */
const CapReachedCard: React.FC<CapReachedCardProps> = ({
  variant = 'paid',
  periodCap = STUDIO_PRICING.paidCap,
  periodResetsAt,
}) => {
  const resetsLabel = periodResetsAt
    ? formatResetDate(periodResetsAt)
    : 'next month';
  const isFree = variant === 'free';

  return (
    <div
      className="studio-panel space-y-4"
      data-testid="studio-cap-reached"
      role="status"
    >
      <div className="studio-tape-stripe rounded-sm opacity-70" aria-hidden />
      <h2 className="text-2xl font-semibold" data-testid="studio-cap-reached-title">
        {isFree ? STUDIO_COPY.paywallHeadline : STUDIO_COPY.monthlyLimitReached}
      </h2>
      <p className="studio-prose text-[var(--studio-muted)] leading-relaxed" data-testid="studio-cap-reached-copy">
        {isFree
          ? STUDIO_COPY.freeCapReached
          : formatCapReachedCopy(periodCap, resetsLabel)}
      </p>
      {isFree ? (
        <Link
          to="/studio/upgrade"
          className="studio-btn-primary no-underline inline-flex"
          data-testid="studio-cap-reached-upgrade"
        >
          {STUDIO_COPY.upgradeCta}
        </Link>
      ) : (
        <p className="studio-fine-print">{STUDIO_COPY.capReachedNeedMore}</p>
      )}
    </div>
  );
};

export default CapReachedCard;
